import { memo, useCallback, useState } from "react";
import { Order } from "../../../../interfaces/domain/menu";
import { Quantity } from "../../inputs/Quantity";
import { formatPrice } from "../../../../utils/formatersPrecio";
import styles from "./CartItem.module.scss";
import { useNavigate } from "react-router-dom";
import { useUIStore } from "../../../../store";

interface CartItemProps {
  order: Order;
}

export const CartItem = memo(
  ({ order }: CartItemProps) => {
    const navigate = useNavigate();
    const [isRemoving, setIsRemoving] =
      useState(false);

    const setSection = useUIStore(
      (s) => s.setSection
    );

    const isCombo =
      Array.isArray(
        order.comboSelection
      ) &&
      order.comboSelection.length > 0;

    const handleEdit =
      useCallback(() => {
        setSection("productModal");

        navigate(
          `?cartItem=${order.cartItemId}`
        );
      }, [
        navigate,
        order.cartItemId,
        setSection,
      ]);

    const handleRemoveAnimation =
      () => {
        setIsRemoving(true);

        setTimeout(() => {
          // remove lo maneja Quantity
        }, 250);
      };

    return (
      <div
        className={`
          ${styles.wrapper}
          ${
            isRemoving
              ? styles.removing
              : ""
          }
        `}
      >
        <div className={styles.container}>
          <div
            className={
              styles.containerPriceTitle
            }
          >
            <p className={styles.title}>
              {order.title}
            </p>

            {!!order.description &&
              !isCombo && (
                <p
                  className={
                    styles.description
                  }
                >
                  {order.description}
                </p>
              )}

            {isCombo && (
              <div
                className={
                  styles.comboDetails
                }
              >
               {/*  <p
                  className={
                    styles.comboLabel
                  }
                >
                  Elegiste:
                </p> */}

                {order.comboSelection!.map(
                  (item) => (
                    <p
                      key={item.id}
                      className={
                        styles.comboItem
                      }
                    >
                      • {item.quantity}x{" "}
                      {item.title}
                    </p>
                  )
                )}
              </div>
            )}

            <p
              className={
                styles.priceUnit
              }
            >
              Precio unitario:{" "}
              {formatPrice(order.price)}
            </p>

            <p
              className={
                styles.priceTotal
              }
            >
              {formatPrice(
                order.price *
                  order.quantity
              )}
            </p>

            <button
              type="button"
              className={
                styles.editButton
              }
              onClick={handleEdit}
            >
              Modificar
            </button>
          </div>
        </div>

        <div
          className={
            styles.containerQuantity
          }
        >
          <Quantity
            idItem={order.cartItemId}
            title={order.title}
            price={order.price}
            photo={order.image_url}
            onRemove={
              handleRemoveAnimation
            }
          />
        </div>
      </div>
    );
  }
);